import { React, useEffect, useState } from "react";
import "./dpr.css";
import "react-responsive-modal/styles.css";
import Breadcrumbs from "../layout/breadcrumb";
import Close from "../../assets/Images/close.png";
import { Modal } from "react-responsive-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Manpower from "./resources/manpower";
import Machinery from "./resources/machinery";
import ScopeChart from "./scopeChart/scopeChart";
import Material from "./resources/material";
import { useNavigate, useLocation } from "react-router-dom";
import RiskRegisterForm from "../risk-register/risk-register-form";
import DprHeader from "../layout/dprHeader";
import IssueRegisterForm from "../issue-register/issue-register-form";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";
import RiskResgisterList from "../risk-register/risk-list-dpr";
import IssueResgisterList from "../issue-register/issue-list-dpr";
import ManpowerList from "./resources/manpower-list";
import MachineryList from "./resources/machinery-list";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";

function Dpr() {
  const location = useLocation();
  const pro = location.state || {};
  console.log(pro);
  const [open, setOpen] = useState(false);
  const [openRisk, setOpenRisk] = useState(false);
  const [openIssu, setOpenIssu] = useState(false);
  const [subId, setSubId] = useState("");
  const [resourceTitle, setResourceTitle] = useState("Manpower");
  const [workpakageName, setWorkPackageName] = useState(pro.WorkPackageName);
  const [openModalRiskList, setOpenModalRiskList] = useState(false);
  const [openModalIssueList, setOpenModalIssueList] = useState(false);
  const [openResourcesList, setOpenResoucresList] = useState(false);
  const [openScopeChart, setOpenScopeChart] = useState(false);
  const [planStart, setPlanStart] = useState("");
  const [planFinish, setPlanFinish] = useState("");
  const [dprName, setDprName] = useState("");
  const [balanceScope, setBalanceScope] = useState("");
  const closeM = (va) => {
    setOpen(va);
  };
  const onCloseModalRisk = () => {
    setOpenRisk(true);
  };
  const onCloseModalIssue = () => {
    setOpenRisk(true);
  };
  const openModalRisk = (id, view = "") => {
    setSubId(id);
    setOpenRisk(true);
  };
  const openModalIssue = (id) => {
    setSubId(id);
    setOpenIssu(true);
  };

  const onClickOpen = (w_id) => {
    setSubId(w_id);
    setOpen(true);
  };
  const onCloseModal = () => setOpen(false);
  const [uomList, setUOMList] = useState([]);
  const [siteeng, setSiteeng] = useState([]);

  const [workPackage_id, setWorkPackageId] = useState(pro.WorkPackageID);

  const [subT, setSubT] = useState([]);

  const getUOM = async () => {
    const uoms = await DPR_API.get_UOM();
    if (uoms && uoms?.UOMList) {
      setUOMList(uoms?.UOMList);
    } else {
      setUOMList([]);
    }
  };
  const getWPO = async () => {
    const wpos = await DPR_API.getWPO();
    if (wpos && wpos?.WPOwnerList) {
      setSiteeng(wpos?.WPOwnerList);
    } else {
      setSiteeng([]);
    }
  };

  const fetchDprDetails = async (workPackage_id) => {
    const dprResponse = await DPR_API.getDprDetails(workPackage_id);
    if (dprResponse && dprResponse?.subtasks?.length > 0) {
      setdprDatas(dprResponse?.subtasks);
    } else {
      setdprDatas([]);
    }
  };

  useEffect(() => {
    fetchDprDetails(workPackage_id);
  }, []);
  const fetchWorkPackages = async () => {
    let state = JSON.parse(localStorage.getItem("state"));
    let obj = {
      EmailID: state.user.Email,
      ProjectGUID: pro?.ProjectGUID,
    };
    const dpr = await DPR_API.GetProjectWorkPackage(obj);
    setSubT(dpr.WorkPackagelList);
  };
  useEffect(() => {
    fetchWorkPackages();
    getUOM();
    getWPO();
  }, []);
  // const handleInputChange = (index, field, value, weightage = "") => {
  //   setdprDatas((prevDprDatas) => {
  //     const updatedDprData = prevDprDatas.map((subtask, idx) => {
  //       if (idx === index) {
  //         const parsedValue = parseFloat(value) || 0;
  //         const finalScope = subtask.FinalScope || 0;
  //         const PreviousProgress = subtask.PreviousProgress || 0;
  //         const currentRate = subtask.CurrentRate || 1; // Ensure no division by zero
  //         const balanceScope =
  //           field === "TodayProgress" || field === "FinalScope"
  //             ? finalScope - (PreviousProgress + parsedValue)
  //             : subtask.BalanceScope;

  //         // Calculate ExpectedFinish date
  //         let expectedFinish = subtask.ExpectedFinish;
  //         if (currentRate > 0 && balanceScope >= 0) {
  //           const daysToFinish = balanceScope / currentRate;
  //           const currentDate = new Date();
  //           currentDate.setDate(
  //             currentDate.getDate() + Math.ceil(daysToFinish)
  //           );
  //           expectedFinish = currentDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  //         }

  //         return {
  //           ...subtask,
  //           [field]:
  //             field === "TodayProgress" || field === "FinalScope"
  //               ? parsedValue
  //               : value,

  //           Cumulative:
  //             field === "TodayProgress"
  //               ? PreviousProgress + parsedValue
  //               : subtask.Cumulative,

  //           ProgressPercentage:
  //             field === "TodayProgress" || field === "FinalScope"
  //               ? finalScope !== 0
  //                 ? (
  //                     ((PreviousProgress + parsedValue) / finalScope) *
  //                     100
  //                   ).toFixed(2)
  //                 : 0
  //               : subtask.ProgressPercentage,

  //           WeightedProgress:
  //             field === "TodayProgress" || field === "Weightage"
  //               ? finalScope !== 0
  //                 ? (
  //                     ((PreviousProgress + parsedValue) / finalScope) *
  //                     (subtask.Weightage || weightage)
  //                   ).toFixed(2)
  //                 : 0
  //               : subtask.WeightedProgress,

  //           BalanceScope: balanceScope,

  //           Status:
  //             field === "TodayProgress" || field === "FinalScope"
  //               ? ((PreviousProgress + parsedValue) / finalScope) * 100 === 100
  //                 ? "Completed"
  //                 : "In Progress"
  //               : subtask.Status,

  //           ExpectedFinish: expectedFinish, // Update ExpectedFinish
  //         };
  //       }
  //       return subtask;
  //     });
  //     return updatedDprData;
  //   });
  // };
  // const handleInputChange = (index, field, value, weightage = "") => {
  //   setdprDatas((prevDprDatas) => {
  //     const updatedDprData = prevDprDatas.map((subtask, idx) => {
  //       if (idx === index) {
  //         const parsedValue = value === "" ? 0 : parseFloat(value) || 0;
  //         const finalScope = subtask.FinalScope || 0;
  //         const PreviousProgress = subtask.PreviousProgress || 0;
  //         const currentRate =
  //           field === "CurrentRate" ? parsedValue : subtask.CurrentRate || 1;
  //         const balanceScope =
  //           field === "TodayProgress" || field === "FinalScope"
  //             ? finalScope -
  //               (PreviousProgress +
  //                 (field === "TodayProgress"
  //                   ? parsedValue
  //                   : subtask.TodayProgress || 0))
  //             : subtask.BalanceScope;

  //         const expectedFinish =
  //           currentRate > 0 && balanceScope >= 0
  //             ? parseFloat((balanceScope / currentRate).toFixed(2))
  //             : 0;

  //         return {
  //           ...subtask,
  //           [field]:
  //             field === "TodayProgress" ||
  //             field === "FinalScope" ||
  //             field === "CurrentRate"
  //               ? parsedValue
  //               : value,

  //           Cumulative:
  //             field === "TodayProgress"
  //               ? PreviousProgress + parsedValue
  //               : subtask.Cumulative,

  //           ProgressPercentage:
  //             field === "TodayProgress" || field === "FinalScope"
  //               ? finalScope !== 0
  //                 ? (
  //                     ((PreviousProgress +
  //                       (field === "TodayProgress"
  //                         ? parsedValue
  //                         : subtask.TodayProgress || 0)) /
  //                       finalScope) *
  //                     100
  //                   ).toFixed(2)
  //                 : 0
  //               : subtask.ProgressPercentage,

  //           WeightedProgress:
  //             field === "TodayProgress" || field === "Weightage"
  //               ? finalScope !== 0
  //                 ? (
  //                     ((PreviousProgress +
  //                       (field === "TodayProgress"
  //                         ? parsedValue
  //                         : subtask.TodayProgress || 0)) /
  //                       finalScope) *
  //                     (subtask.Weightage || weightage)
  //                   ).toFixed(2)
  //                 : 0
  //               : subtask.WeightedProgress,

  //           BalanceScope: balanceScope,

  //           Status:
  //             field === "TodayProgress" || field === "FinalScope"
  //               ? ((PreviousProgress +
  //                   (field === "TodayProgress"
  //                     ? parsedValue
  //                     : subtask.TodayProgress || 0)) /
  //                   finalScope) *
  //                   100 ===
  //                 100
  //                 ? "Completed"
  //                 : "In Progress"
  //               : subtask.Status,

  //           ExpectedFinish: expectedFinish,
  //         };
  //       }
  //       return subtask;
  //     });
  //     return updatedDprData;
  //   });
  // };
  const handleInputChange = (index, field, value, weightage = "") => {
    setdprDatas((prevDprDatas) => {
      const updatedDprData = prevDprDatas.map((subtask, idx) => {
        if (idx === index) {
          const parsedValue = value === "" ? 0 : parseFloat(value) || 0;
          console.log(parsedValue, "parsedValue", "---");
          const finalScope = parseFloat(subtask.FinalScope) || 0;
          const PreviousProgress = parseFloat(subtask.PreviousProgress) || 0;

          // Use the new PlannedStart value if updating the start date
          const startDate =
            field === "PlannedStart"
              ? new Date(value)
              : subtask.PlannedStart
              ? new Date(subtask.PlannedStart)
              : null;

          // Use the new PlannedFinish value if updating the finish date
          const finishDate =
            field === "PlannedFinish"
              ? new Date(value)
              : subtask.PlannedFinish
              ? new Date(subtask.PlannedFinish)
              : null;

          const currentDate = new Date();

          // Balance scope calculation
          const balanceScope =
            field === "TodayProgress" || field === "FinalScope"
              ? finalScope -
                (PreviousProgress +
                  (field === "TodayProgress"
                    ? parsedValue
                    : subtask.TodayProgress || 0))
              : subtask.BalanceScope || 0;

          // Duration calculation
          const duration =
            startDate && finishDate
              ? Math.max(
                  0,
                  Math.floor((finishDate - startDate) / (1000 * 60 * 60 * 24)) +
                    1
                )
              : 0;

          // Baseline rate calculation
          const baselineRate =
            duration > 0 && finalScope > 0
              ? (finalScope / duration).toFixed(2)
              : 0;

          // Current rate calculation
          const elapsedDays =
            startDate && currentDate
              ? Math.max(
                  0,
                  Math.ceil((currentDate - startDate) / (1000 * 60 * 60 * 24))
                )
              : 0;
          const currentRate =
            elapsedDays > 0
              ? ((PreviousProgress + parsedValue) / elapsedDays).toFixed(2)
              : 0;

          // Asking rate calculation
          const remainingDays =
            finishDate && currentDate
              ? Math.max(
                  0,
                  Math.ceil((finishDate - currentDate) / (1000 * 60 * 60 * 24))
                )
              : 0;
          const askingRate =
            remainingDays > 0 && finalScope > 0
              ? (balanceScope / remainingDays).toFixed(2)
              : 0;

          // Expected finish calculation
          const expectedFinish =
            currentRate > 0 && balanceScope >= 0
              ? parseFloat((balanceScope / currentRate).toFixed(2))
              : 0;

          return {
            ...subtask,
            [field]:
              field === "TodayProgress" ||
              field === "FinalScope" ||
              field === "CurrentRate"
                ? parsedValue
                : value,

            Duration: duration,
            BaselineRate: baselineRate,
            CurrentRate: currentRate,
            AskingRate: askingRate,

            Cumulative:
              field === "TodayProgress"
                ? PreviousProgress + parsedValue
                : subtask.Cumulative,

            ProgressPercentage:
              field === "TodayProgress" || field === "FinalScope"
                ? finalScope !== 0
                  ? (
                      ((PreviousProgress +
                        (field === "TodayProgress"
                          ? parsedValue
                          : subtask.TodayProgress || 0)) /
                        finalScope) *
                      100
                    ).toFixed(2)
                  : 0
                : subtask.ProgressPercentage,

            WeightedProgress:
              field === "TodayProgress" || field === "Weightage"
                ? finalScope !== 0
                  ? (
                      ((PreviousProgress +
                        (field === "TodayProgress"
                          ? parsedValue
                          : subtask.TodayProgress || 0)) /
                        finalScope) *
                      (subtask.Weightage || weightage)
                    ).toFixed(2)
                  : 0
                : subtask.WeightedProgress,

            BalanceScope: balanceScope,

            Status:
              field === "TodayProgress" || field === "FinalScope"
                ? (
                    ((PreviousProgress +
                      (field === "TodayProgress"
                        ? parsedValue
                        : subtask.TodayProgress || 0)) /
                      finalScope) *
                    100
                  ).toFixed(0) == 100
                  ? "Completed"
                  : (
                      ((PreviousProgress +
                        (field === "TodayProgress"
                          ? parsedValue
                          : subtask.TodayProgress || 0)) /
                        finalScope) *
                      100
                    ).toFixed(0) < 1
                  ? "Not Started"
                  : "In Progress"
                : subtask.Status,

            ExpectedFinish: expectedFinish,
          };
        }
        return subtask;
      });
      return updatedDprData;
    });
  };

  const handleChange = (index, field, file) => {
    setdprDatas((prevInputs) =>
      prevInputs.map((row, rowIndex) => {
        if (rowIndex === index) {
          return {
            ...row,
            [field]:
              // file && file[0] ? URL.createObjectURL(file[0]) : row[field],
              file && file[0] ? file[0] : row[field],
          };
        }
        return row;
      })
    );
  };

  const [dprDatas, setdprDatas] = useState([]);
  const handleAddTaskClick = async () => {
    const state = localStorage.getItem("state");
    const usr = JSON.parse(state);
    const responseD = await DPR_API.getDprId(usr?.user?.user_id);
    const newRow = {
      USERID: usr?.user?.user_id,
      ProjectID: pro.project_id,
      ProjectName: pro.Project_Name,
      WorkPackageGUID: workPackage_id,
      WorkPackage: workpakageName,
      DPRID: responseD.DPRID,
      Subtask: "",
      Weightage: 0,
      InitialScope: 0,
      FinalScope: null,
      UOM: "",
      TodayProgress: null,
      PlannedStart: null,
      PlannedFinish: null,
      ActualStart: null,
      ActualFinish: null,
      PreviousProgress: 0,
      Cumulative: 0,
      ProgressPercentage: 0,
      WeightedProgress: null,
      BalanceScope: null,
      ScopeChart: "scope chart",
      Duration: null,
      BaselineRate: null,
      CurrentRate: null,
      AskingRate: null,
      ExpectedFinish: null,
      Status: "Not Started",
      WPOwnerID: null,
      // resourcesAssigned: null,
      // RiskFormLink: null,
      // IssueFormLink: null,
      // ResourcesFormLink: null,
      UploadPicture: null,
      DPRType: "Created",
      IsConfirm: "0",
    };

    setdprDatas((prevData) => [...prevData, newRow]);
  };
  const handleRemoveTaskClick = async (dprIdToRemove) => {
    const state = localStorage.getItem("state");
    const user = JSON.parse(state);
    const res = await DPR_API.deleteRowDpr(dprIdToRemove, user?.user?.user_id);
    if (res.Status == 200) {
      setdprDatas((prevData) =>
        prevData.filter((row) => row.DPRID !== dprIdToRemove)
      );
    } else {
      toast.error(res.Message);
    }
  };

  const handleChangeWorkpackage = (e) => {
    setWorkPackageId(e.target.value);
    setWorkPackageName(e.target.selectedOptions[0].text);
    fetchDprDetails(e.target.value);
  };
  const validateForm = (dataArray) => {
    const errors = [];

    dataArray.forEach((data, index) => {
      for (const key in data) {
        const value = data[key];

        if (value === null || value === undefined || value === "") {
          errors.push(`Object ${index + 1}: ${key} is required.`);
        }
      }
    });

    if (errors.length > 0) {
      console.error("Validation Errors:", errors);
      toast.error("Please fill in all the required fields");
      return false;
    }

    return true;
  };
  const handleSubmit = async () => {
    // console.log(dprDatas);
    // if (!validateForm(dprDatas)) return;

    const updatedData = await Promise.all(
      dprDatas.map(async (data) => {
        if (typeof data.UploadPicture === "object") {
          const response = await PROJECT_API.saveDocument(data.UploadPicture);
          return { ...data, UploadPicture: response.fileUrl, IsConfirm: 1 };
        } else {
          return { ...data, IsConfirm: 1 };
        }
      })
    );

    const createResponse = await DPR_API.createDpr(updatedData);

    if (createResponse.Status === 201) {
      toast.success("Dpr Created Successfully!");
    }
  };
  const deleteAllRows = async () => {
    const state = localStorage.getItem("state");
    const user = JSON.parse(state);
    const res = await DPR_API.deleteAllRows(user?.user?.user_id);
  };
  console.log(dprDatas, "dpr data");

  const handleScopeChartClick = (val) => {
    setSubId(val?.DPRID);
    setOpenScopeChart(true);
    setPlanStart(val?.PlannedStart);
    setPlanFinish(val?.PlannedFinish);
    setDprName(val.Subtask);
    setBalanceScope(val.BalanceScope);
  };

  return (
    <div className="pb-5">
      <Breadcrumbs title="Project DPR" menu="" link="DPR" />
      <DprHeader project={pro} />

      <div className="card p-3 mt-3 card-none">
        {/* <h4>{dprDatas.data[0]?.projectName}</h4> */}

        <div className="row mt-0 p-2">
          <div className="col-4" style={{ paddingLeft: 0 }}>
            {/* <label>My Projects</label> */}
            <div>
              <select
                value={workPackage_id}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
                onChange={(e) => {
                  handleChangeWorkpackage(e);
                }}
              >
                {/* <option value={""}>Select Work package</option> */}
                {subT?.map((val) => (
                  <option value={val?.WorkPackageID}>
                    {val?.WorkPackageName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex flex-start column-gap-5">
          <div>
            <button
              className="btn btn-primary shadow-none"
              onClick={handleAddTaskClick}
            >
              Add Task
            </button>
          </div>
        </div>
        <div>
          <div className="table-container-dpr">
            <table id="custom-table-dpr">
              <thead className="table-header-dpr">
                <tr>
                  {dprDatas.length > 0 &&
                  dprDatas.some((data) => data.IsConfirm == "0") ? (
                    <th></th>
                  ) : (
                    ""
                  )}
                  {/* <th></th> */}
                  <th>Subtask</th>
                  <th>Weightage</th>
                  <th>Initial Scope</th>
                  <th>Final Scope</th>
                  <th>UOM</th>
                  <th>Previous Progress</th>
                  <th>Today’s Progress</th>
                  <th>Cumulative</th>
                  <th>Progress %</th>
                  <th>Weighted Progress</th>
                  <th>Balance Scope</th>
                  <th>Planned Start/Baseline Start</th>
                  <th>Planned Finish/Baseline Finish</th>
                  <th>Scope Chart</th>
                  <th>Duration</th>
                  <th>Baseline Rate</th>
                  <th>Current Rate</th>
                  <th>Asking Rate</th>
                  <th>Actual Start</th>
                  <th>Actual Finish</th>
                  <th>Expected Finish</th>
                  <th>Status</th>
                  <th>WP Owner</th>
                  <th>Resources Assigned</th>
                  <th>Risk</th>
                  <th>Issue</th>
                  <th>Resources</th>
                  <th>Upload Picture</th>
                  <th>Dpr Approval</th>
                  <th>Comment</th>
                  {/* <th>Toolbox talk</th>
                  <th>Work Permit</th> */}
                </tr>
              </thead>
              <tbody>
                <tr style={{ height: "40px" }}>
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <b>100</b>
                  </td>
                  {[
                    ...Array(
                      dprDatas.length > 0 &&
                        dprDatas.some((data) => data.IsConfirm == "0")
                        ? 29
                        : 28
                    ),
                  ].map(() => (
                    <td key={Math.random()}></td>
                  ))}
                </tr>
                <tr style={{ height: "40px" }}>
                  <td>
                    <b style={{ textWrap: "nowrap" }}>{workpakageName}</b>
                  </td>

                  <td>
                    <b>20</b>
                  </td>
                  {[
                    ...Array(
                      dprDatas.length > 0 &&
                        dprDatas.some((data) => data.IsConfirm == "0")
                        ? 29
                        : 28
                    ),
                  ].map(() => (
                    <td key={Math.random()}></td>
                  ))}
                </tr>
                {dprDatas.map((val, ins) => (
                  <>
                    <tr>
                      {dprDatas.length > 0 &&
                      dprDatas.some((data) => data.IsConfirm == "0") ? (
                        <td style={{ textAlign: "right" }}>
                          {/* {val.DPRID + val.IsConfirm} */}
                          <img
                            src={Close}
                            width={20}
                            onClick={(e) =>
                              val.IsConfirm == 0 &&
                              handleRemoveTaskClick(val.DPRID)
                            }
                            style={{
                              cursor:
                                val.IsConfirm == 0 ? "pointer" : "not-allowed",
                            }}
                            disabled={val.IsConfirm == 0}
                          />
                        </td>
                      ) : (
                        ""
                      )}

                      <td>
                        <input
                          type="text"
                          onChange={(e) =>
                            handleInputChange(ins, "Subtask", e.target.value)
                          }
                          value={val.Subtask}
                        />
                        {/* {val?.subtask} */}
                      </td>
                      <td>{(100 / dprDatas.length).toFixed(2)}</td>
                      <td>
                        <input
                          onInput={(e) =>
                            handleInputChange(
                              ins,
                              "InitialScope",
                              parseInt(e.target.value, 10)
                            )
                          }
                          value={val.InitialScope}
                          type="number"
                        />
                      </td>
                      <td>
                        <input
                          value={val.FinalScope}
                          onInput={(e) =>
                            handleInputChange(
                              ins,
                              "FinalScope",
                              parseInt(e.target.value, 10)
                            )
                          }
                          type="number"
                        />
                      </td>
                      <td>
                        <select
                          value={val.UOM}
                          onChange={(e) => {
                            handleInputChange(ins, "UOM", e.target.value);
                          }}
                        >
                          <option value={""}>Select UOM </option>
                          {uomList?.length
                            ? uomList?.map((val) => (
                                <option value={val?.UOMShortName}>
                                  {val?.UOMShortName}
                                </option>
                              ))
                            : ""}
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          value={val.PreviousProgress}
                          disabled
                        ></input>
                      </td>
                      <td>
                        <input
                          type="number"
                          value={val.TodayProgress}
                          onInput={(e) =>
                            handleInputChange(
                              ins,
                              "TodayProgress",
                              parseInt(e.target.value, 10),
                              (100 / dprDatas.length).toFixed(2)
                            )
                          }
                        />
                      </td>
                      <td>
                        <input value={val.Cumulative} type="text" disabled />
                      </td>
                      <td>
                        <input
                          value={val.ProgressPercentage}
                          type="text"
                          disabled
                        />
                      </td>
                      <td>
                        <input
                          value={val.WeightedProgress}
                          type="text"
                          disabled
                        />
                      </td>
                      <td>
                        <input value={val.BalanceScope} type="text" disabled />
                      </td>
                      <td>
                        <input
                          value={val.PlannedStart}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "PlannedStart",
                              e.target.value
                            );
                          }}
                          min={new Date().toISOString().split("T")[0]}
                          type="date"
                          style={{ width: 200 }}
                        />
                      </td>
                      <td>
                        <input
                          value={val.PlannedFinish}
                          type="date"
                          min={val.PlannedStart}
                          style={{ width: 200 }}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "PlannedFinish",
                              e.target.value
                            );
                          }}
                          disabled={val.PlannedStart === null}
                        />
                      </td>
                      <td>
                        <button
                          style={{ width: 100, border: "0px solid" }}
                          onClick={() => handleScopeChartClick(val)}
                        >
                          Scope Chart
                        </button>
                      </td>
                      <td>
                        <input
                          value={val.Duration}
                          onChange={(e) => {
                            handleInputChange(ins, "Duration", e.target.value);
                          }}
                          type="text"
                        />
                      </td>
                      <td>
                        <input
                          value={val.BaselineRate}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "BaselineRate",
                              e.target.value
                            );
                          }}
                          type="number"
                        />
                      </td>
                      <td>
                        <input
                          value={val.CurrentRate}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "CurrentRate",
                              e.target.value
                            );
                          }}
                          type="number"
                        />
                      </td>
                      <td>
                        <input
                          value={val.AskingRate}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "AskingRate",
                              e.target.value
                            );
                          }}
                          type="number"
                        />
                      </td>
                      <td>
                        <input
                          value={val.ActualStart}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "ActualStart",
                              e.target.value
                            );
                          }}
                          min={new Date().toISOString().split("T")[0]}
                          type="date"
                          style={{ width: 200 }}
                        />
                      </td>
                      <td>
                        <input
                          value={val.ActualFinish}
                          type="date"
                          min={val.ActualStart}
                          onChange={(e) => {
                            handleInputChange(
                              ins,
                              "ActualFinish",
                              e.target.value
                            );
                          }}
                          style={{ width: 200 }}
                          disabled={val.ActualStart === null}
                        />
                      </td>
                      <td>
                        <input
                          value={val.ExpectedFinish}
                          type="text"
                          // style={{ width: 200 }}
                          // onChange={(e) => {
                          //   handleInputChange(
                          //     ins,
                          //     "ExpectedFinish",
                          //     e.target.value
                          //   );f
                          // }}
                          disabled
                        />
                      </td>
                      <td>
                        <p>{val.Status}</p>
                      </td>
                      <td>
                        <select
                          value={val.WPOwnerID}
                          onChange={(e) => {
                            handleInputChange(ins, "WPOwnerID", e.target.value);
                          }}
                        >
                          <option value={""}>Select WP Owner </option>
                          {siteeng?.length
                            ? siteeng?.map((val) => (
                                <option value={val?.ID}>{val?.Name}</option>
                              ))
                            : ""}
                        </select>
                      </td>
                      <td>{val.resourcesAssigned}</td>
                      <td>
                        <div className="d-flex">
                          <button
                            className="btn btn-primary"
                            onClick={() => openModalRisk(val?.DPRID)}
                            // disabled={!val.DPRID}
                          >
                            Risk
                          </button>
                          <button
                            className="show-reaource"
                            onClick={() => {
                              setSubId(val?.DPRID);
                              setOpenModalRiskList(true);
                            }}
                            // disabled={!val.DPRID}
                          >
                            View
                          </button>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex">
                          <button
                            className="btn btn-primary"
                            onClick={() => openModalIssue(val?.DPRID)}
                            // disabled={!val.DPRID}
                          >
                            Issue
                          </button>
                          <button
                            className="show-reaource"
                            onClick={() => {
                              setSubId(val?.DPRID);
                              setOpenModalIssueList(true);
                            }}
                            // disabled={!val.DPRID}
                          >
                            View
                          </button>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex">
                          <button
                            className="btn btn-primary"
                            onClick={() => onClickOpen(val?.DPRID)}
                            // disabled={!val.DPRID}
                          >
                            Open
                          </button>

                          <button
                            className="show-reaource"
                            onClick={() => {
                              setSubId(val?.DPRID);
                              setOpenResoucresList(true);
                            }}

                            // disabled={!val.DPRID}
                          >
                            View
                          </button>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <input
                            type="file"
                            accept="image/jpeg, image/png, image/gif"
                            style={{ width: 200 }}
                            onChange={(e) => {
                              handleChange(
                                ins,
                                "UploadPicture",
                                e.target.files
                              );
                            }}
                          />
                          {val.UploadPicture && (
                            <img
                              src={
                                typeof val.UploadPicture == "object"
                                  ? URL.createObjectURL(val.UploadPicture)
                                  : val.UploadPicture
                              }
                              alt="Uploaded Preview"
                              style={{
                                width: "40px",
                                height: "40px",
                                marginTop: "-8px",
                                marginLeft: "10px",
                              }}
                            />
                          )}
                        </div>
                      </td>
                      {/* <td>
                        <div className="d-flex align-items-center">
                          <input
                            type="file"
                            accept=".pdf, .doc, .docx, .xls, .xlsx"
                            onChange={(e) => {
                              handleChange(ins, "toolboxTalk", e.target.files);
                            }}
                          />
                          {val.toolboxTalk && (
                            <a
                              href={val.toolboxTalk} // Display the first uploaded image
                              //  alt="Uploaded Preview"
                              target="_blank"
                            >
                              Click
                            </a>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <input
                            type="file"
                            accept=".pdf, .doc, .docx, .xls, .xlsx"
                            onChange={(e) => {
                              handleChange(ins, "workPermit", e.target.files);
                            }}
                          />
                          {val.workPermit && (
                            <a
                              href={val.workPermit} // Display the first uploaded image
                              //  alt="Uploaded Preview"
                              target="_blank"
                            >
                              Click
                            </a>
                          )}
                        </div>
                      </td> */}
                      <td>{val.DPRApprovalStatus}</td>
                      <td>{val.Remark}</td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* ))} */}
        <div className="row mt-4">
          <div class="d-flex justify-content-end">
            <div style={{ margin: 10 }}>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
            <div style={{ margin: 10 }}>
              <button className="btn btn-danger" onClick={deleteAllRows}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="projectallowcate">
        <Modal open={open} onClose={onCloseModal} center>
          <div className="d-flex justify-content-between">
            <div>
              <span className="resorces">Add Resource {resourceTitle}</span>
            </div>
            <div>
              <img
                src={Close}
                width={20}
                onClick={() => {
                  setOpen(false);
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <hr />
          <div className="row" id="dpr-tab">
            <Tabs>
              <TabList>
                <Tab
                  onClick={() => {
                    setResourceTitle("Manpower");
                  }}
                >
                  Manpower
                </Tab>
                <Tab
                  onClick={() => {
                    setResourceTitle("Machinery");
                  }}
                >
                  Machinery
                </Tab>
                {/* <Tab
                  onClick={() => {
                    setResourceTitle("Material");
                  }}
                >
                  Material
                </Tab> */}
              </TabList>
              <TabPanel>
                <Manpower
                  closeM={closeM}
                  subId={subId}
                  project={pro}
                  wpId={workPackage_id}
                />
              </TabPanel>
              <TabPanel>
                <Machinery
                  closeM={closeM}
                  subId={subId}
                  project={pro}
                  wpId={workPackage_id}
                />
              </TabPanel>
              {/* <TabPanel>
                <Material
                  closeM={closeM}
                  subId={subId}
                  project={pro}
                  wpId={workPackage_id}
                />
              </TabPanel> */}
            </Tabs>
          </div>

          {/* <div className='row mt-2'>
                        <div class="d-flex justify-content-center">
                            <div style={{ margin: 10 }}>
                                <button className='btn btn-primary'>Submit</button>
                            </div>
                            <div style={{ margin: 10 }}>
                                <button className='btn btn-danger'>Cancel</button>
                            </div>
                        </div>
                    </div> */}
        </Modal>
      </div>
      <Modal open={openRisk} onClose={onCloseModalRisk} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk Register Form</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenRisk(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <RiskRegisterForm subId={subId} onSubmit={() => setOpenRisk(false)} />
      </Modal>

      <Modal open={openIssu} onClose={onCloseModalIssue} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue Register Form</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenIssu(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <IssueRegisterForm subId={subId} onSubmit={() => setOpenIssu(false)} />
      </Modal>

      <Modal
        open={openModalRiskList}
        onClose={onCloseModalIssue}
        center
        styles={{
          modal: {
            minWidth: "850px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setSubId("");
                setOpenModalRiskList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <RiskResgisterList subId={subId} />
      </Modal>
      <Modal
        open={openModalIssueList}
        onClose={onCloseModalIssue}
        center
        styles={{
          modal: {
            minWidth: "850px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setSubId("");
                setOpenModalIssueList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <IssueResgisterList subId={subId} />
      </Modal>
      <Modal
        open={openResourcesList}
        onClose={() => {}}
        center
        styles={{
          modal: {
            minWidth: "850px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource {resourceTitle} List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenResoucresList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row" id="dpr-tab">
          <Tabs>
            <TabList>
              <Tab
                onClick={() => {
                  setResourceTitle("Manpower");
                }}
              >
                Manpower
              </Tab>
              <Tab
                onClick={() => {
                  setResourceTitle("Machinery");
                }}
              >
                Machinery
              </Tab>
              {/* <Tab
                onClick={() => {
                  setResourceTitle("Material");
                }}
              >
                Material
              </Tab> */}
            </TabList>
            <TabPanel>
              <ManpowerList subId={subId} />
            </TabPanel>
            <TabPanel>
              <MachineryList subId={subId} />
            </TabPanel>
            {/* <TabPanel>
              <Material subId={subId} />
            </TabPanel> */}
          </Tabs>
        </div>
      </Modal>
      <Modal open={openScopeChart} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Scope Chart</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenScopeChart(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <ScopeChart
          subId={subId}
          planStart={planStart}
          planFinish={planFinish}
          onSubmit={() => setOpenScopeChart(false)}
          DPRName={dprName}
          balanceScope={balanceScope}
          project={pro}
        />
      </Modal>
    </div>
  );
}

export default Dpr;
